import axios from "axios";
import React, { useEffect, useState } from "react";
import { renderError } from "../../../helpers/errors";
import { createFilterQueryString } from "../../../helpers/helpers";
import { createModalProps, createOptions } from "../../../helpers/selects";
import api from "../../../services/api";
import InputSelect from "../../InputSelect";
import { ModalCreateCompany } from "../../ModalCreateCompany";

export const SelectCustomerCompany = ({selectedCustomerCompany, setSelectedCustomerCompany, isMulti, changeCompanies, preloadedCompanies, create}) => {
    const [customerCompanies, setCustomerCompanies] = useState([]);
    const [search, setSearch] = useState('');
    const [noOptionsText, setNoOptionsText] = useState('');
    const [showCreate, setShowCreate] = useState(false);

    window.controller = null;

    const minSearch = 1;

    useEffect(() => {
        if (!preloadedCompanies || preloadedCompanies.length === 0) return;
        setCustomerCompanies(prev => {
            const toAdd = preloadedCompanies.filter(p => !prev.some(c => c.id === p.id));
            return toAdd.length ? [...toAdd, ...prev] : prev;
        });
    }, [preloadedCompanies]);

    useEffect(() => {
        searchCustomerCompanies();
    }, [search]);
    
    useEffect(() => {
        checkIfNeedToGet();
    }, [selectedCustomerCompany]);

    useEffect(() => {
        if(changeCompanies){
            changeCompanies(customerCompanies);
        }
    }, [customerCompanies]);

    const checkIfNeedToGet = () => {
        let companiesIds = isMulti ? selectedCustomerCompany : [selectedCustomerCompany];
        let arrayFilters = [];

        companiesIds.map(companyId => {
            if(companyId === null) return;
            if(!customerCompanies.some(customerCompany => customerCompany.id === companyId)){
                arrayFilters.push([
                    `[id][equal]=${companyId}`,
                ]);
            }
        });

        if(arrayFilters.length > 0){
            getCustomerCompanies(arrayFilters);
        } else {
            // Para forçar atualização da mensagem "Digite mais x caracteres"
            setSearch('');
        }
    }

    const clearOptions = () => {
        handleSetCustomerCompanies([], true)
    }

    const searchCustomerCompanies = () => {
        if(search.length < minSearch) {
            let diff = minSearch - search.length;
            setNoOptionsText(`Digite mais ${diff} ${diff === 1 ? 'caracter' : 'caracteres'}`);
            clearOptions();
            if(window.requestController){
                window.requestController.abort();
            };
            return;
        };

        let arrayFilters = [
            [
                '[type][contain]=customer',
                `[code][equal]=${search}`,
            ],
            [
                '[type][contain]=customer',
                `[trade_name][contain]=${search}`,
            ]
        ];

        getCustomerCompanies(arrayFilters);        
    }

    const getCustomerCompanies = arrayFilters => {
        let stringFilters = createFilterQueryString(arrayFilters);

        if(window.requestController){
            window.requestController.abort();
        };

        window.requestController = new AbortController();
        
        handleSetCustomerCompanies([]);
        setNoOptionsText('Carregando...');

        api.get(`/company?${stringFilters}`, {
            signal: window.requestController.signal
        }).then(res => {
            handleSetCustomerCompanies(res.data.resources);
        }).catch(error => {
            console.log(error, arrayFilters);
            if(error.code !== undefined){
                renderError(error);
            }
        });
    }

    const handleSetCustomerCompanies = (resources, fromClear = false) => {
        let currentSelectedCustomerCompanies = getSelectedCustomerCompanies();

        let toCustomerCompanies = resources.filter(resource => {
            return !currentSelectedCustomerCompanies.some(current => current.id === resource.id);
        });

        setCustomerCompanies([...currentSelectedCustomerCompanies, ...toCustomerCompanies]);
        if(!fromClear){
            setNoOptionsText(toCustomerCompanies.length === 0 ? 'Nenhum resultado encontrado' : '');
        }
    }

    const getSelectedCustomerCompanies = () => {
        return customerCompanies.filter(customerCompany => {
            if(isMulti){
                return selectedCustomerCompany.includes(customerCompany.id);
            } else {
                return selectedCustomerCompany === customerCompany.id;
            }
        });
    }

    const selectCreated = company => {
        setShowCreate(false);
        setSelectedCustomerCompany(isMulti ? [...selectedCustomerCompany, company.id] : company.id);
    }

    return (
        <>
            {create &&
                <ModalCreateCompany
                    type={['customer']}
                    {...createModalProps(create)}
                    show={showCreate}
                    close={() => setShowCreate(false)}
                    companyStored={selectCreated}
                    showSuccess={false}
                />
            }
            <InputSelect
                noOptionsText={noOptionsText}
                label={`Empresa`}
                options={createOptions(customerCompanies, ['code', 'trade_name'], 'id')} 
                value={selectedCustomerCompany} 
                change={setSelectedCustomerCompany}
                isMulti={isMulti === true}
                setSearch={value => setSearch(value)}
                onCreate={create ? () => setShowCreate(true) : undefined}
            />
        </>
    );
}

export default SelectCustomerCompany;